module.exports = __webpack_public_path__ + "static/media/orangeLines.1941cdae.svg";